import axios from "axios";

const token = localStorage.getItem("token_key");

const config = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

const configNoData = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

const configNoToken = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const configForm = {
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  },
};

const configJson = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
};

export const getData = async (url) => {
  const result = await axios.get(
    `${process.env.REACT_APP_URL_API + url}`,
    config
  );
  return result;
};

export const postData = async (url, data) => {
  const result = await axios.post(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configForm
  );
  return result;
};

export const postDataJson = async (url, data) => {
  const result = await axios.post(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configJson
  );
  return result;
};

export const postDataNoData = async (url, data) => {
  const result = await axios.post(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configNoData
  );
  return result;
};


export const postDataNoToken = async (url, data) => {
  const result = await axios.post(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configNoToken
  );
  return result;
};

export const deleteData = async (url)=>{
  const result = await axios.delete(
    `${process.env.REACT_APP_URL_API + url}`,
    config
  );
  return result;
}

export const putData = async (url, data) => {
  const result = await axios.put(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configForm
  );
  return result;
};

export const putDataNoToken = async (url, data) => {
  const result = await axios.put(
    `${process.env.REACT_APP_URL_API + url}`,
    data,
    configNoData
  );
  return result;
};